import { useEffect, useMemo, useState } from "react";
import { getTopper } from "../Service/Api";
import LazyLoad from "react-lazyload";

const getSessionYearLabel = (endYear) => `${endYear - 1}-${endYear}`;
const getWrappedIndex = (index, total) => ((index % total) + total) % total;

const TopperX = () => {
  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData1 = await getTopper();
        const topperData = Array.isArray(topperData1)
          ? topperData1.sort((a, b) => parseFloat(b.division) - parseFloat(a.division))
          : [];

        const classXData = topperData.filter((item) => item.class === "X");
        let year = new Date().getFullYear(); // Example current year from date API: 2026
        let matchedData = [];

        // Try current session first (e.g. 2025-2026), then move backwards
        while (year >= 2000 && matchedData.length === 0) {
          const targetSessionYear = getSessionYearLabel(year);
          matchedData = classXData.filter((item) => item.sessionYear === targetSessionYear);

          if (matchedData.length === 0) {
            year -= 1;
          }
        }

        setData(matchedData);
      } catch (error) {
        console.error("Error fetching topper data:", error);
      }
    };
    fetchData();
  }, []);

  const emptyArray = [
       {name:"Student Name",per:"90%"},
       {name:"Student Name",per:"90%"}
  ];

  const sortedData = useMemo(
    () => data.slice().sort((a, b) => parseFloat(b.division) - parseFloat(a.division)),
    [data]
  );

  const visibleData = useMemo(() => {
    if (sortedData.length >= 3) {
      // Pattern: 1,0,2 then 2,1,3 then 3,2,4...
      const offsets = [1, 0, 2];
      return offsets.map((offset) => sortedData[getWrappedIndex(currentIndex + offset, sortedData.length)]);
    }
    return sortedData;
  }, [sortedData, currentIndex]);

  return (
    <>
      <div className="row">
        {(visibleData.length > 0 ? visibleData : emptyArray).map((item, index) => (
          <div className="col-lg-4 col-md-4 col-sm-6 col-12 item" key={`${item._id || item.name}-${index}`}>
            <div className="topperdiv">
              <div className="star">
                {item.division ? `${item.division}%` : item.per}
              </div>
              <div className="toppertaj">
                <LazyLoad
                  offset={10}
                  placeholder={
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg"
                      alt="Loading..."
                      className="img-fluid"
                    />
                  }
                >
                  <img
                    src={
                      item.attachments && item.attachments[0]
                        ? `https://webapi.entab.info/api/image/${item.attachments[0]}`
                        : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg"
                    }
                    className="img-fluid"
                  />
                </LazyLoad>
              </div>
              <div className="topperdesc">
                <p className="name">{item.name}</p>
                <p>{item.stream}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="topper-block text-center mb-3">
        <button
          type="button"
          className="me-2 prev_btn"
          onClick={() => setCurrentIndex((prev) => prev - 1)}
        >
         <i className="bi bi-arrow-bar-left"></i>
        </button>
        <button
          type="button"
          className="next_btn"
          onClick={() => setCurrentIndex((prev) => prev + 1)}
        >
         <i className="bi bi-arrow-bar-right"></i>
        </button>
      </div>
    </>
  );
};

export default TopperX;
